import classNames from 'classnames'
import PropTypes from 'prop-types'

import { mobileAppDownloadPath } from 'lib/urls'
import { InfoButton, CloseButton } from 'components/buttons'
import { DismissUI } from '../dismiss-ui'

import css from './banner.scss'

export const AppPromoBanner = ({ onClose }) => (
  <div
    className={classNames(css.appPromoBanner, 'xsmall text-center pvl phxl')}
  >
    <CloseButton
      className={('btn close', css.appPromoBannerCloseBtn)}
      onClick={onClose}
    />
    <p>
      Quick heads up! You need the free Babylist app to add items from any
      store.
    </p>
    <InfoButton href={mobileAppDownloadPath()} size="small" pill>
      Get the Babylist App
    </InfoButton>
  </div>
)

AppPromoBanner.dismissId = 'app-promo-banner'

AppPromoBanner.propTypes = {
  onClose: PropTypes.func,
}

AppPromoBanner.defaultProps = {
  onClose: () => {},
}

export const DismissableAppPromoBanner = () => (
  <DismissUI dismissDays={1} dismissId="app-promo-banner">
    {(isDismissed, onDismiss) =>
      !isDismissed && <AppPromoBanner onClose={onDismiss} />
    }
  </DismissUI>
)
